"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Config_1 = require("../../Config");
var localStore_1 = require("../localStore");
function hydrate(target, propertyKey, decriptor) {
    var originalFunction = decriptor.value;
    decriptor.value = function decriptorRewrite() {
        var _this = this;
        var args = arguments;
        var store = Config_1.config.getOption('store');
        if (!store) {
            return originalFunction.apply(this, args);
        }
        var stored = localStore_1.localStore(Config_1.config.getOption('store')).get(args[0]);
        return Promise.resolve(stored)
            .then(function (value) { return value || originalFunction.apply(_this, args); })
            .catch(function () { return originalFunction.apply(_this, args); });
    };
    return decriptor;
}
exports.hydrate = hydrate;
